import React, { useState } from 'react';
import { useThemeMode } from '../../ThemeContext';
import { usePermissions } from '../../contexts/PermissionContext';
import {
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Tooltip
} from '@mui/material';
import {
  MoreVert as MoreVertIcon,
  Edit as EditIcon,
  Delete as DeleteIcon
} from '@mui/icons-material';

const FolderOptionsMenu = ({ folder, onRename, onDelete, anchorEl, onClose, onOpen }) => {
  const { mode } = useThemeMode();
  const { hasEditPermission, hasDeletePermission } = usePermissions();
  
  const handleRename = () => {
    onClose();
    onRename(folder);
  };

  const handleDelete = () => {
    onClose();
    onDelete(folder);
  };

  // Check if user has any permissions
  const canEdit = hasEditPermission('document');
  const canDelete = hasDeletePermission('document');
  const hasAnyPermission = canEdit || canDelete;

  // Don't render menu if user has no permissions
  if (!hasAnyPermission) {
    return null;
  }

  return (
    <>
      <Tooltip title="Folder options">
        <IconButton
          size="small"
          onClick={onOpen}
          sx={{
            color: mode === 'dark' ? '#999' : '#666666',
            '&:hover': {
              backgroundColor: mode === 'dark' 
                ? 'rgba(255, 255, 255, 0.1)' 
                : 'rgba(0, 0, 0, 0.1)'
            }
          }}
        >
          <MoreVertIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={onClose}
        PaperProps={{
          sx: {
            backgroundColor: mode === 'dark' ? '#1a1a1a' : '#ffffff',
            border: `1px solid ${mode === 'dark' ? '#333' : '#e0e0e0'}`,
            borderRadius: '8px',
            boxShadow: mode === 'dark' 
              ? '0 4px 12px rgba(0, 0, 0, 0.3)' 
              : '0 4px 12px rgba(0, 0, 0, 0.15)',
            '& .MuiMenuItem-root': {
              color: mode === 'dark' ? '#FFFFFF' : '#222222',
              '&:hover': {
                backgroundColor: mode === 'dark' ? '#26C3C0' : '#26C3C0',
                color: '#FFFFFF',
                '& .MuiListItemIcon-root': {
                  color: '#FFFFFF',
                }
              },
              '& .MuiListItemIcon-root': {
                color: mode === 'dark' ? '#999' : '#666666',
              }
            }
          }
        }}
      >
        {canEdit && (
          <MenuItem onClick={handleRename}>
            <ListItemIcon>
              <EditIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Rename</ListItemText>
          </MenuItem>
        )}
        {canDelete && (
          <MenuItem onClick={handleDelete}>
            <ListItemIcon>
              <DeleteIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Delete</ListItemText>
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

export default FolderOptionsMenu;
